import React from 'react';
import '../style/cookies.css';


export default function CookiesMessage(props) {
  return (
    <div className="cookies_container">
        <div className="cookies_content">
            <div className="cookies_title">
                <h2>Cookies</h2>
                <img src={process.env.PUBLIC_URL + '/icons/cookies.png'} width="50" alt="cookie" />
            </div>
            <hr></hr>
            <div>
                <p>This site uses cookies to offer you the best service. These are the minimum necessary cookies.</p>
            </div>
            <div>
                <p>You will never receive advertising or commercial links.</p>
            </div>
            <hr></hr>
            <div>
                <button 
                    className="validate_cookies"
                    onClick={() => {
                        document.querySelector('.cookies_content').style.animation = 'cookies_hide 1s linear'
                        setTimeout(() => props.setCookiesDisplay(false), 950);
                    }}>Ok, i understand</button>
            </div>
        </div>
    </div>
  )
}
